import React, { useEffect, useState } from 'react'
import { useGlobal, useGlobalDispatch } from '../../core/GlobalContext'
import { REGISTER_DUCK, VALIDATION_STATUS } from '../../core/actions'
import { bytesToHumanReadableSize } from '../../utils/misc'
import { validateRegisterDocuments } from '../../utils/validations'
import Text from '../text'
import * as styles from './UploadDocument.css'

export const UploadDocument = ({ title, type }) => {
  const [fileDetails, setFileDetails] = useState(null)
  const {
    registerState: { message, accountType },
  } = useGlobal()
  const { registerDispatch } = useGlobalDispatch()

  const handleFileChange = event => {
    setFileDetails(event.target.files[0])
  }

  useEffect(() => {
    validateRegisterDocuments(title, type, fileDetails)(registerDispatch)
  }, [fileDetails, title, type])

  useEffect(() => {
    registerDispatch({
      type: REGISTER_DUCK.DOC_CHANGE,
      payload: { documents: { [type]: { size: fileDetails?.size } } },
    })
  }, [fileDetails])

  useEffect(() => {
    setFileDetails(null)
    document.getElementById(type).value = ''
  }, [accountType])

  return (
    <div>
      <div className={styles.inputWrapper}>
        <label className={styles.label} htmlFor={type}>
          <Text color='#1a73e8'>Upload document</Text>
          <ion-icon name='cloud-upload-outline'></ion-icon>
        </label>
        <input
          type='file'
          id={type}
          name={type}
          onChange={handleFileChange}
          accept='image/png, image/jpg, image/jpeg, application/pdf'
          className={styles.uploadInput}
        />
      </div>
      {fileDetails?.name && (
        <div className={styles.fileDetails}>
          <Text size='0.9' color='#35A37E'>
            {fileDetails?.name}
          </Text>
          <Text size='0.8' color='var(--grey-text-subtitle-color)'>
            {bytesToHumanReadableSize(fileDetails?.size)}
            {fileDetails?.lastModifiedDate &&
              ` — ${fileDetails?.lastModifiedDate.toDateString()} ${fileDetails?.lastModifiedDate.toLocaleTimeString()}`}
          </Text>
        </div>
      )}
      {message[type]?.status === VALIDATION_STATUS.SUCCESS ? (
        <Text size='0.8' color='#35A37E'>
          {message[type]?.value}
        </Text>
      ) : (
        <Text size='0.8' color='var(--red-text-color)'>
          {message[type]?.value}
        </Text>
      )}
    </div>
  )
}
